module.exports = __webpack_public_path__ + "static/media/exclamation-square.5498575b.svg";